const GetImage = (image) => {
  return require(`./../../public/image/${image}`);
};

export default GetImage;
